module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Title:",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "Enter Report Title"
    },
    model: {
      value: (_vm.myController.Incident.Title),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Title", $$v)
      },
      expression: "myController.Incident.Title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-6 col-lg-6 "
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Prepared By:",
      "prop": "AddedBy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": " Select Staff Member"
    },
    model: {
      value: (_vm.myController.Incident.AddedBy),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "AddedBy", $$v)
      },
      expression: "myController.Incident.AddedBy"
    }
  }, _vm._l((_vm.myController.staffmembers), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.AddedBy == '0') ? _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other report prepared by types"
    },
    model: {
      value: (_vm.myController.Incident.ReportPreparedByOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ReportPreparedByOther", $$v)
      },
      expression: "myController.Incident.ReportPreparedByOther"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Date:",
      "prop": "AddedOn"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.myController.Incident.AddedOn),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "AddedOn", $$v)
      },
      expression: "myController.Incident.AddedOn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Report Time:",
      "prop": "AddedOn"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerFormat,
      "format": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerFormat,
      "placeholder": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder
    },
    model: {
      value: (_vm.myController.Incident.AddOnTime),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "AddOnTime", $$v)
      },
      expression: "myController.Incident.AddOnTime"
    }
  })], 1)], 1), _vm._v(" "), (_vm.myController.Incident.AddedBy == '0') ? _c('span', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-6 col-lg-6 "
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': _vm.myController.Incident.AddedBy !== '0'
    },
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other report prepared by types"
    },
    model: {
      value: (_vm.myController.Incident.ReportPreparedByOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ReportPreparedByOther", $$v)
      },
      expression: "myController.Incident.ReportPreparedByOther"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('hydroware-other-input-placeholder')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('hydroware-other-input-placeholder')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Venue:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Aquatic Venue"
    },
    model: {
      value: (_vm.myController.PoolIdEdit),
      callback: function($$v) {
        _vm.$set(_vm.myController, "PoolIdEdit", $$v)
      },
      expression: "myController.PoolIdEdit"
    }
  }, _vm._l((_vm.myController.pools), function(item) {
    return _c('el-option', {
      key: item.PoolId,
      attrs: {
        "label": item.PoolName,
        "value": item.PoolId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Location:",
      "prop": "Location"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": "Where did incident occur"
    },
    model: {
      value: (_vm.myController.Incident.LocationText),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "LocationText", $$v)
      },
      expression: "myController.Incident.LocationText"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Incident Date:",
      "prop": "IncidentDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "MM-dd-yyyy",
      "placeholder": "Pick a date"
    },
    on: {
      "blur": _vm.hydroware_picker_hasBlurred
    },
    model: {
      value: (_vm.myController.Incident.IncidentDate),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "IncidentDate", $$v)
      },
      expression: "myController.Incident.IncidentDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Incident Time:",
      "prop": "IncidentTime"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerFormat,
      "format": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerFormat,
      "placeholder": _vm.myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder
    },
    model: {
      value: (_vm.myController.Incident.IncidentTime),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "IncidentTime", $$v)
      },
      expression: "myController.Incident.IncidentTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Incident Type:",
      "prop": "PoolType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Incident Type"
    },
    model: {
      value: (_vm.myController.Incident.PoolType),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "PoolType", $$v)
      },
      expression: "myController.Incident.PoolType"
    }
  }, _vm._l((_vm.myController.IncidentTypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.PoolType == 'Other') ? _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other incident types"
    },
    model: {
      value: (_vm.myController.Incident.OtherTypeIncident),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "OtherTypeIncident", $$v)
      },
      expression: "myController.Incident.OtherTypeIncident"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Inc. Severity:",
      "prop": "Severity"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Incident Severity"
    },
    model: {
      value: (_vm.myController.Incident.Severity),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Severity", $$v)
      },
      expression: "myController.Incident.Severity"
    }
  }, _vm._l((_vm.myController.Severitys), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.PoolType == 'Other') ? _c('span', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('hydroware-other-input-placeholder')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('hydroware-other-input-placeholder')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': _vm.myController.Incident.PoolType !== 'Other'
    },
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other incident types"
    },
    model: {
      value: (_vm.myController.Incident.OtherTypeIncident),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "OtherTypeIncident", $$v)
      },
      expression: "myController.Incident.OtherTypeIncident"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('hydroware-other-input-placeholder')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nature Of Incident:",
      "prop": "NatureOfIncident"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-no-resize-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "Enter Nature of the Incident",
      "rows": 2,
      "maxlength": 250
    },
    model: {
      value: (_vm.myController.Incident.NatureOfIncident),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "NatureOfIncident", $$v)
      },
      expression: "myController.Incident.NatureOfIncident"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Description  :",
      "prop": "Description"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-no-resize-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "Describe the incident",
      "rows": 2,
      "maxlength": 400
    },
    model: {
      value: (_vm.myController.Incident.Description),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Description", $$v)
      },
      expression: "myController.Incident.Description"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Violator:",
      "prop": "ViolatorClass"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select type"
    },
    model: {
      value: (_vm.myController.Incident.ViolatorClass),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ViolatorClass", $$v)
      },
      expression: "myController.Incident.ViolatorClass"
    }
  }, _vm._l((_vm.myController.Violator), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.ViolatorClass == 'Other') ? _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other violator types"
    },
    model: {
      value: (_vm.myController.Incident.ViolatorOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ViolatorOther", $$v)
      },
      expression: "myController.Incident.ViolatorOther"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Behavior:",
      "prop": "BehaviorType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Behavior Type"
    },
    model: {
      value: (_vm.myController.Incident.BehaviorType),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "BehaviorType", $$v)
      },
      expression: "myController.Incident.BehaviorType"
    }
  }, _vm._l((_vm.myController.IncidentBehavior), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.BehaviorType == 'Other') ? _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter behaviour"
    },
    model: {
      value: (_vm.myController.Incident.OtherTypeBehavior),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "OtherTypeBehavior", $$v)
      },
      expression: "myController.Incident.OtherTypeBehavior"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.myController.Incident.ViolatorClass == 'Other' ||
    _vm.myController.Incident.BehaviorType == 'Other') ? _c('span', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': _vm.myController.Incident.ViolatorClass !== 'Other'
    },
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter other violator types"
    },
    model: {
      value: (_vm.myController.Incident.ViolatorOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ViolatorOther", $$v)
      },
      expression: "myController.Incident.ViolatorOther"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': _vm.myController.Incident.BehaviorType !== 'Other'
    },
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter behaviour"
    },
    model: {
      value: (_vm.myController.Incident.OtherTypeBehavior),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "OtherTypeBehavior", $$v)
      },
      expression: "myController.Incident.OtherTypeBehavior"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Manager On Duty",
      "prop": "ManagerId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Staff Member"
    },
    model: {
      value: (_vm.myController.Incident.ManagerOnDuty),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ManagerOnDuty", $$v)
      },
      expression: "myController.Incident.ManagerOnDuty"
    }
  }, _vm._l((_vm.myController.staffmembers), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.myController.Incident.ManagerOnDuty == '0') ? _c('span', {
    staticClass: "hidden-sm hidden-md hidden-lg hidden-xl"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter manager on duty"
    },
    model: {
      value: (_vm.myController.Incident.ManagerOnDutyOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ManagerOnDutyOther", $$v)
      },
      expression: "myController.Incident.ManagerOnDutyOther"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Location Of Manager on Duty",
      "prop": "Area"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter Location",
      "maxlength": 30
    },
    model: {
      value: (_vm.myController.Incident.Area),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Area", $$v)
      },
      expression: "myController.Incident.Area"
    }
  })], 1)], 1), _vm._v(" "), (_vm.myController.Incident.ManagerOnDuty == '0') ? _c('span', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('el-form-item', {
    staticClass: "hydroware-other"
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': _vm.myController.Incident.ManagerOnDuty !== '0'
    },
    attrs: {
      "maxlength": 150,
      "placeholder": "Enter manager on duty"
    },
    model: {
      value: (_vm.myController.Incident.ManagerOnDutyOther),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "ManagerOnDutyOther", $$v)
      },
      expression: "myController.Incident.ManagerOnDutyOther"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('hydroware-other-input-placeholder')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Response:",
      "prop": "Response"
    }
  }, [_c('el-input', {
    staticClass: "hydroware-no-resize-textarea",
    attrs: {
      "type": "textarea",
      "placeholder": "How did staff respond",
      "rows": 2,
      "maxlength": 400
    },
    model: {
      value: (_vm.myController.Incident.Response),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Response", $$v)
      },
      expression: "myController.Incident.Response"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Police:",
      "prop": "Police"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.myController.Incident.Police),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "Police", $$v)
      },
      expression: "myController.Incident.Police"
    }
  })], 1), _vm._v(" "), (_vm.myController.Incident.Police) ? _c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl",
    attrs: {
      "prop": "PoliceCase"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": " Enter Police Dept. Case"
    },
    model: {
      value: (_vm.myController.Incident.PoliceCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "PoliceCase", $$v)
      },
      expression: "myController.Incident.PoliceCase"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fire Department:",
      "prop": "FireDepartment"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.myController.Incident.FireDepartment),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "FireDepartment", $$v)
      },
      expression: "myController.Incident.FireDepartment"
    }
  })], 1), _vm._v(" "), (_vm.myController.Incident.FireDepartment) ? _c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl",
    attrs: {
      "prop": "FireDepartmentCase"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "Enter Fire Dept. Case"
    },
    model: {
      value: (_vm.myController.Incident.FireDepartmentCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "FireDepartmentCase", $$v)
      },
      expression: "myController.Incident.FireDepartmentCase"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('el-form-item', {
    attrs: {
      "label": "EMS:",
      "prop": "lastname"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.myController.Incident.EMS),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "EMS", $$v)
      },
      expression: "myController.Incident.EMS"
    }
  })], 1), _vm._v(" "), (_vm.myController.Incident.EMS) ? _c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl",
    attrs: {
      "prop": "EMSCase"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "Enter EMS Case"
    },
    model: {
      value: (_vm.myController.Incident.EMSCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "EMSCase", $$v)
      },
      expression: "myController.Incident.EMSCase"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.myController.Incident.Police || _vm.myController.Incident.FireDepartment || _vm.myController.Incident.EMS) ? _c('span', [_c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-xs col-sm-4",
    attrs: {
      "prop": "PoliceCase"
    }
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': !_vm.myController.Incident.Police
    },
    attrs: {
      "maxlength": 30,
      "placeholder": " Enter Police Dept. Case"
    },
    model: {
      value: (_vm.myController.Incident.PoliceCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "PoliceCase", $$v)
      },
      expression: "myController.Incident.PoliceCase"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-xs col-sm-4",
    attrs: {
      "prop": "FireDepartmentCase"
    }
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': !_vm.myController.Incident.FireDepartment
    },
    attrs: {
      "maxlength": 30,
      "placeholder": "Enter Fire Dept. Case"
    },
    model: {
      value: (_vm.myController.Incident.FireDepartmentCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "FireDepartmentCase", $$v)
      },
      expression: "myController.Incident.FireDepartmentCase"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hydroware-other-checkbox hidden-xs col-sm-4",
    attrs: {
      "prop": "EMSCase"
    }
  }, [_c('el-input', {
    class: {
      'hydroware-ishidden': !_vm.myController.Incident.EMS
    },
    attrs: {
      "maxlength": 30,
      "placeholder": "Enter EMS Case"
    },
    model: {
      value: (_vm.myController.Incident.EMSCase),
      callback: function($$v) {
        _vm.$set(_vm.myController.Incident, "EMSCase", $$v)
      },
      expression: "myController.Incident.EMSCase"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    }
  }, [_c('button', {
    staticClass: "btn btn-white btn-sm",
    class: [{
      hydroware_hidden: _vm.$hydrowareSecurityJS.disableDataEntry_A('incidents', _vm.isAddingOrEditing)
    }],
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": _vm.myController.addInvolvedParty
    }
  }, [_vm._v("\n                    Add Involved Party\n                ")])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "hydroware-table table table-striped table-bordered table-hover gride TFtable",
    staticStyle: {
      "max-width": "100%",
      "overflow-x": "auto"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.myController.Incident.IncidentInvolvedPartyList.length < 1 || _vm.myController.Incident.IncidentInvolvedPartyList == null) ? _c('tr', {}, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.myController.$hydrowareCommonJS.hydrowareMsgForNoData) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.myController.Incident.IncidentInvolvedPartyList), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', {
      staticClass: "hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"
    }, [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter Name"
      },
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Phone #:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('(###) ###-####'),
        expression: "'(###) ###-####'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "placeholder": "Enter Phone Number"
      },
      model: {
        value: (item.PhoneNumber),
        callback: function($$v) {
          _vm.$set(item, "PhoneNumber", $$v)
        },
        expression: "item.PhoneNumber"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Age:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('###'),
        expression: "'###'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 3,
        "placeholder": "Enter Age"
      },
      model: {
        value: (item.Age),
        callback: function($$v) {
          _vm.$set(item, "Age", $$v)
        },
        expression: "item.Age"
      }
    })], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"
    }, [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Address:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter Address"
      },
      model: {
        value: (item.Address),
        callback: function($$v) {
          _vm.$set(item, "Address", $$v)
        },
        expression: "item.Address"
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("City:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter City"
      },
      model: {
        value: (item.City),
        callback: function($$v) {
          _vm.$set(item, "City", $$v)
        },
        expression: "item.City"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("State:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 2,
        "placeholder": "Enter State"
      },
      model: {
        value: (item.State),
        callback: function($$v) {
          _vm.$set(item, "State", $$v)
        },
        expression: "item.State"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Zip Code:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('#####-####'),
        expression: "'#####-####'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 10,
        "placeholder": "Enter Zip Code"
      },
      model: {
        value: (item.ZipCode),
        callback: function($$v) {
          _vm.$set(item, "ZipCode", $$v)
        },
        expression: "item.ZipCode"
      }
    })], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter Name"
      },
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter Address"
      },
      model: {
        value: (item.Address),
        callback: function($$v) {
          _vm.$set(item, "Address", $$v)
        },
        expression: "item.Address"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter City"
      },
      model: {
        value: (item.City),
        callback: function($$v) {
          _vm.$set(item, "City", $$v)
        },
        expression: "item.City"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter State"
      },
      model: {
        value: (item.State),
        callback: function($$v) {
          _vm.$set(item, "State", $$v)
        },
        expression: "item.State"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('############'),
        expression: "'############'"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Enter Zip Code"
      },
      model: {
        value: (item.ZipCode),
        callback: function($$v) {
          _vm.$set(item, "ZipCode", $$v)
        },
        expression: "item.ZipCode"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('(###) ###-####'),
        expression: "'(###) ###-####'"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Enter Phone Number"
      },
      model: {
        value: (item.PhoneNumber),
        callback: function($$v) {
          _vm.$set(item, "PhoneNumber", $$v)
        },
        expression: "item.PhoneNumber"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: ('###'),
        expression: "'###'"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Enter Age"
      },
      model: {
        value: (item.Age),
        callback: function($$v) {
          _vm.$set(item, "Age", $$v)
        },
        expression: "item.Age"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hydroware-1-button-column"
    }, [(_vm.$hydrowareSecurityJS.canDelete_A('incidents')) ? _c('button', {
      staticClass: "el-button el-button--danger el-button--small",
      staticStyle: {
        "background-color": "#ff4949!important"
      },
      attrs: {
        "type": "button",
        "title": ""
      },
      on: {
        "click": function($event) {
          return _vm.myController.removeInvolved(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "color": "white !important"
      }
    })]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    }
  }, [_c('button', {
    staticClass: "btn btn-white btn-sm",
    class: [{
      hydroware_hidden: _vm.$hydrowareSecurityJS.disableDataEntry_A('incidents', _vm.isAddingOrEditing)
    }],
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        return _vm.myController.addWitness()
      }
    }
  }, [_vm._v("\n                        Add Witness\n                    ")])])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "hydroware-table table table-striped table-bordered table-hover gride TFtable",
    staticStyle: {
      "max-width": "100%",
      "overflow-x": "auto"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.myController.Incident.IncidentWitnessList.length < 1 || _vm.myController.Incident.IncidentWitnessList == null) ? _c('tr', {}, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.myController.$hydrowareCommonJS.hydrowareMsgForNoData) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.myController.Incident.IncidentWitnessList), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', {
      staticClass: "hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"
    }, [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter Name"
      },
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Phone #:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('(###) ###-####'),
        expression: "'(###) ###-####'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "placeholder": "Enter Phone Number"
      },
      model: {
        value: (item.PhoneNumber),
        callback: function($$v) {
          _vm.$set(item, "PhoneNumber", $$v)
        },
        expression: "item.PhoneNumber"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Age:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('###'),
        expression: "'###'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 3,
        "placeholder": "Enter Age"
      },
      model: {
        value: (item.Age),
        callback: function($$v) {
          _vm.$set(item, "Age", $$v)
        },
        expression: "item.Age"
      }
    })], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"
    }, [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Address:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter Address"
      },
      model: {
        value: (item.Address),
        callback: function($$v) {
          _vm.$set(item, "Address", $$v)
        },
        expression: "item.Address"
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("City:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 30,
        "placeholder": "Enter City"
      },
      model: {
        value: (item.City),
        callback: function($$v) {
          _vm.$set(item, "City", $$v)
        },
        expression: "item.City"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("State:")]), _vm._v(" "), _c('el-input', {
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 2,
        "placeholder": "Enter State"
      },
      model: {
        value: (item.State),
        callback: function($$v) {
          _vm.$set(item, "State", $$v)
        },
        expression: "item.State"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "hydroware-label-fixed"
    }, [_vm._v("Zip Code:")]), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('#####-####'),
        expression: "'#####-####'"
      }],
      staticClass: "hydroware-input-for-fixed-label",
      attrs: {
        "type": "text",
        "maxlength": 10,
        "placeholder": "Enter Zip Code"
      },
      model: {
        value: (item.ZipCode),
        callback: function($$v) {
          _vm.$set(item, "ZipCode", $$v)
        },
        expression: "item.ZipCode"
      }
    })], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter Name"
      },
      model: {
        value: (item.Name),
        callback: function($$v) {
          _vm.$set(item, "Name", $$v)
        },
        expression: "item.Name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter Address"
      },
      model: {
        value: (item.Address),
        callback: function($$v) {
          _vm.$set(item, "Address", $$v)
        },
        expression: "item.Address"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter City"
      },
      model: {
        value: (item.City),
        callback: function($$v) {
          _vm.$set(item, "City", $$v)
        },
        expression: "item.City"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "maxlength": 30,
        "placeholder": "Enter State"
      },
      model: {
        value: (item.State),
        callback: function($$v) {
          _vm.$set(item, "State", $$v)
        },
        expression: "item.State"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "Enter Zip Code",
        "maxlength": "12"
      },
      model: {
        value: (item.ZipCode),
        callback: function($$v) {
          _vm.$set(item, "ZipCode", $$v)
        },
        expression: "item.ZipCode"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      directives: [{
        name: "hydromask",
        rawName: "v-hydromask",
        value: ('(###) ###-####'),
        expression: "'(###) ###-####'"
      }],
      attrs: {
        "type": "text",
        "placeholder": "EnterEEEEE Phone Number"
      },
      model: {
        value: (item.PhoneNumber),
        callback: function($$v) {
          _vm.$set(item, "PhoneNumber", $$v)
        },
        expression: "item.PhoneNumber"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-md hidden-xs hidden-sm"
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "Enter Age",
        "maxlength": "3"
      },
      model: {
        value: (item.Age),
        callback: function($$v) {
          _vm.$set(item, "Age", $$v)
        },
        expression: "item.Age"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "hydroware-1-button-column"
    }, [(_vm.$hydrowareSecurityJS.canDelete_A('incidents')) ? _c('button', {
      staticClass: "el-button el-button--danger el-button--small",
      staticStyle: {
        "background-color": "#ff4949!important"
      },
      attrs: {
        "type": "button",
        "title": ""
      },
      on: {
        "click": function($event) {
          return _vm.myController.removeWitness(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "color": "white !important"
      }
    })]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    }
  }, [_c('button', {
    staticClass: "btn btn-white btn-sm",
    class: [{
      hydroware_hidden: _vm.$hydrowareSecurityJS.disableDataEntry_A('incidents', _vm.isAddingOrEditing)
    }],
    attrs: {
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        return _vm.myController.addStaff()
      }
    }
  }, [_vm._v("\n                        Add Employee\n                    ")])])]), _vm._v(" "), _c('table', {
    staticClass: "hydroware-table table table-striped table-bordered table-hover gride TFtable",
    staticStyle: {
      "max-width": "100%",
      "overflow-x": "auto"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [(_vm.myController.Incident.IncidentStaffOnDutyList.length < 1 || _vm.myController.Incident.IncidentStaffOnDutyList == null) ? _c('tr', {}, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-weight": "700",
      "opacity": "0.6",
      "color": "gray"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.myController.$hydrowareCommonJS.hydrowareMsgForNoData) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.myController.Incident.IncidentStaffOnDutyList), function(item, index) {
    return _c('tr', {
      key: item.Id
    }, [_c('td', [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "Select Employee"
      },
      model: {
        value: (item.StaffId),
        callback: function($$v) {
          _vm.$set(item, "StaffId", $$v)
        },
        expression: "item.StaffId"
      }
    }, _vm._l((_vm.myController.staffmembers), function(item1) {
      return _c('el-option', {
        key: item1.Id,
        attrs: {
          "label": item1.Name,
          "value": item1.Id
        }
      })
    }), 1), _vm._v(" "), (item.StaffId == '0') ? _c('el-form-item', [_c('el-input', {
      attrs: {
        "maxlength": 150,
        "placeholder": "Enter other Enter other staff on duty"
      },
      model: {
        value: (item.StaffOther),
        callback: function($$v) {
          _vm.$set(item, "StaffOther", $$v)
        },
        expression: "item.StaffOther"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "hydroware-1-button-column"
    }, [(_vm.$hydrowareSecurityJS.canDelete_A('incidents')) ? _c('button', {
      staticClass: "el-button el-button--danger el-button--small",
      staticStyle: {
        "background-color": "#ff4949!important"
      },
      attrs: {
        "type": "button",
        "title": ""
      },
      on: {
        "click": function($event) {
          return _vm.myController.removeStaff(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "color": "white !important"
      }
    })]) : _vm._e()])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "font-weight": "700"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("\n                    Involved party(s)\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            Name\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            Address\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            City\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-state-column"
  }, [_vm._v("\n                            State\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-zipcode-column"
  }, [_vm._v("\n                            Zip Code\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-phonenumber-column"
  }, [_vm._v("\n                            Phone Number\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-age-column"
  }, [_vm._v("\n                             Age\n                        ")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "font-weight": "700"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Witness")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            Name\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            Address\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm"
  }, [_vm._v("\n                            City\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-state-column"
  }, [_vm._v("\n                            State\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-zipcode-column"
  }, [_vm._v("\n                            Zip Code\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-phonenumber-column"
  }, [_vm._v("\n                            Phone Number\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-md hidden-xs hidden-sm hydroware-age-column"
  }, [_vm._v("\n                            Age\n                        ")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticStyle: {
      "float": "left",
      "padding-left": "10px",
      "font-weight": "700"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("\n                        Staff on Duty\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n                            Name\n                        ")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10445e1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HealthSafety/IncidentAccident/incidentForm.vue
// module id = 771
// module chunks = 1